// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#left-panel {
  width: 220px;
  max-width: 220px;
  min-height: calc(100dvh - 58px);
  height: 100%;
  background: var(--surface-700);
  transition: width 0.2s ease;
}

.cp-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0.625rem;
  border-bottom: 1px solid var(--shadow-color);
}
.cp-logo img {
  max-width: 180px;
  max-height: 48px;
  object-fit: contain;
}

.cp-nav-list,
.cp-nav-submenu {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cp-nav-item {
  position: relative;
}
.cp-nav-item.active > .cp-nav-link {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.08);
}
.cp-nav-item.active > .cp-nav-link::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 5px;
  left: 0;
  top: 0;
  background: var(--primary-color);
}

.cp-nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 16px;
  color: rgba(225, 225, 225, 0.85);
  text-decoration: none;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.cp-nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
  text-decoration: none;
}
.cp-nav-link i.fas {
  width: 18px;
  text-align: center;
  flex-shrink: 0;
  font-size: 14px;
}

.cp-nav-action {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.cp-nav-parent > .cp-nav-link {
  justify-content: space-between;
}
.cp-nav-parent > .cp-nav-link .fas, .cp-nav-parent > .cp-nav-link .menu-item-parent, .cp-nav-parent > .cp-nav-link .menu-item-child {
  flex: 1 1 auto;
}
.cp-nav-parent > .cp-nav-link .fas {
  flex: 0 0 18px;
}

.collapse-sign {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-left: auto;
}
.collapse-sign em {
  display: block;
  width: 8px;
  height: 8px;
  border-right: 2px solid rgba(225, 225, 225, 0.5);
  border-bottom: 2px solid rgba(225, 225, 225, 0.5);
  transform: rotate(45deg);
  transition: transform 0.2s ease;
}
.collapse-sign em.open {
  transform: rotate(-135deg);
}

.cp-nav-submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease;
  background: rgba(0, 0, 0, 0.15);
}
.cp-nav-submenu .cp-nav-link {
  padding-left: 32px;
  font-size: 13px;
  color: rgba(225, 225, 225, 0.78);
}

.cp-nav-parent.open > .cp-nav-submenu {
  max-height: 2000px;
}

.subSubMenu {
  background: #1a1e24;
}
.subSubMenu .cp-nav-link {
  padding-left: 46px;
  font-size: 12px;
}
.subSubMenu::before {
  left: 25px;
}

.menu-item-parent,
.menu-item-child {
  overflow: hidden;
  text-overflow: ellipsis;
}

:host-context(.zuggit-base) #left-panel {
  background: var(--surface-700);
}
:host-context(.zuggit-base) #left-panel .cp-logo {
  border-bottom: 1px solid var(--surface-800);
}
:host-context(.zuggit-base) #left-panel .cp-nav-item.active > .cp-nav-link,
:host-context(.zuggit-base) #left-panel .cp-nav-link:active {
  background: var(--surface-600) !important;
}
:host-context(.zuggit-base) #left-panel .cp-nav-link:hover {
  background-color: var(--surface-600);
}
:host-context(.zuggit-base) #left-panel .cp-nav-submenu {
  background: var(--surface-800);
}
:host-context(.zuggit-base) #left-panel .cp-nav-submenu .cp-nav-link:hover {
  background-color: var(--surface-500);
}

@media only screen and (max-width: var(--media-tablet)) and (min-width: 0px) {
  #left-panel {
    width: 300px;
    max-width: 300px;
    left: -300px !important;
  }
  #left-panel .cp-logo {
    padding: 32px 12px;
  }
  #left-panel .cp-nav-link {
    font-size: 16px;
  }
  #left-panel .cp-nav-link i.fas {
    font-size: 14px;
    margin-right: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/layout/navigation/navigation.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,8BAAA;EACA,2BAAA;AADJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4CAAA;AAAJ;AACI;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;AACR;;AAGA;;EAEI,gBAAA;EACA,SAAA;EACA,UAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;AACI;EACI,sBAAA;EACA,qCAAA;AACR;AAAQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;AAEZ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AAAJ;AACI;EACI,WAAA;EACA,qCAAA;EACA,qBAAA;AACR;AACI;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACR;;AAEA;EACI,eAAA;EACA,yBAAA;UAAA,iBAAA;AACJ;;AAGI;EACI,8BAAA;AAAR;AAEQ;EACI,cAAA;AAAZ;AAEQ;EACI,cAAA;AAAZ;;AAKA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAFJ;AAGI;EACI,cAAA;EACA,UAAA;EACA,WAAA;EACA,gDAAA;EACA,iDAAA;EACA,wBAAA;EACA,+BAAA;AADR;AAEQ;EACI,0BAAA;AAAZ;;AAKA;EACI,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;AAFJ;AAGI;EACI,kBAAA;EACA,eAAA;EACA,gCAAA;AADR;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;AAEI;EACI,kBAAA;EACA,eAAA;AAAR;AAEI;EACI,UAAA;AAAR;;AAIA;;EAEI,gBAAA;EACA,uBAAA;AADJ;;AAGA;EACI,8BAAA;AAAJ;AACI;EACI,2CAAA;AACR;AACI;;EAEI,yCAAA;AACR;AACI;EACI,oCAAA;AACR;AACI;EACI,8BAAA;AACR;AAAQ;EACI,oCAAA;AAEZ;;AAEA;EACI;IACI,YAAA;IACA,gBAAA;IACA,uBAAA;EACN;EAAM;IACI,kBAAA;EAEV;EAAM;IACI,eAAA;EAEV;EADU;IACI,eAAA;IACA,iBAAA;EAGd;AACF","sourcesContent":["\n\n#left-panel{\n    width:220px;\n    max-width:220px;\n    min-height:calc(100dvh - 58px);\n    height:100%;\n    background: var(--surface-700);\n    transition:width 0.2s ease;\n}\n.cp-logo{\n    display:flex;\n    align-items:center;\n    justify-content:center;\n    padding:1rem 0.625rem;\n    border-bottom:1px solid var(--shadow-color);\n    img{\n        max-width:180px;\n        max-height:48px;\n        object-fit:contain;\n    }\n}\n// ── Nav list reset ────────────────────────────────────────────────────────\n.cp-nav-list,\n.cp-nav-submenu{\n    list-style:none;\n    margin:0;\n    padding:0;\n}\n// ── Nav items ─────────────────────────────────────────────────────────────\n.cp-nav-item{\n    position:relative;\n    &.active > .cp-nav-link{\n        color:#fff !important;\n        background:rgba(255, 255, 255, 0.08);\n        &::before{\n            content:\"\";\n            position:absolute;\n            height:100%;\n            width:5px;\n            left:0;\n            top:0;\n            background:var(--primary-color);\n        }\n    }\n}\n// ── Nav links ─────────────────────────────────────────────────────────────\n.cp-nav-link{\n    display:flex;\n    align-items:center;\n    gap:10px;\n    padding:9px 16px;\n    color:rgba(225, 225, 225, 0.85);\n    text-decoration:none;\n    font-size:14px;\n    white-space:nowrap;\n    overflow:hidden;\n    cursor:pointer;\n    transition:background 0.15s, color 0.15s;\n    &:hover{\n        color:#fff;\n        background:rgba(255, 255, 255, 0.06);\n        text-decoration:none;\n    }\n    i.fas{\n        width:18px;\n        text-align:center;\n        flex-shrink:0;\n        font-size:14px;\n    }\n}\n.cp-nav-action{\n    cursor:pointer;\n    user-select:none;\n}\n// ── Parent items with children ────────────────────────────────────────────\n.cp-nav-parent{\n    > .cp-nav-link{\n        justify-content:space-between;\n        // icon + text side\n        .fas, .menu-item-parent, .menu-item-child{\n            flex:1 1 auto;\n        }\n        .fas{\n            flex:0 0 18px;\n        }\n    }\n}\n// ── Collapse indicator ────────────────────────────────────────────────────\n.collapse-sign{\n    display:inline-flex;\n    align-items:center;\n    justify-content:center;\n    width:16px;\n    height:16px;\n    flex-shrink:0;\n    margin-left:auto;\n    em{\n        display:block;\n        width:8px;\n        height:8px;\n        border-right:2px solid rgba(225, 225, 225, 0.5);\n        border-bottom:2px solid rgba(225, 225, 225, 0.5);\n        transform:rotate(45deg);\n        transition:transform 0.2s ease;\n        &.open{\n            transform:rotate(-135deg);\n        }\n    }\n}\n// ── CSS accordion — submenu ───────────────────────────────────────────────\n.cp-nav-submenu{\n    max-height:0;\n    overflow:hidden;\n    transition:max-height 0.25s ease;\n    background:rgba(0, 0, 0, 0.15);\n    .cp-nav-link{\n        padding-left:32px;\n        font-size:13px;\n        color:rgba(225, 225, 225, 0.78);\n    }\n}\n.cp-nav-parent.open > .cp-nav-submenu{\n    max-height:2000px; // large enough for any submenu\n}\n// ── Sub-sub-menu (3rd level) ──────────────────────────────────────────────\n.subSubMenu{\n    background:#1a1e24;\n    .cp-nav-link{\n        padding-left:46px;\n        font-size:12px;\n    }\n    &::before{\n        left:25px;\n    }\n}\n// ── Span helpers (kept from original for icon spacing) ────────────────────\n.menu-item-parent,\n.menu-item-child{\n    overflow:hidden;\n    text-overflow:ellipsis;\n}\n:host-context(.zuggit-base) #left-panel{\n    background:var(--surface-700);\n    .cp-logo{\n        border-bottom:1px solid var(--surface-800);\n    }\n    .cp-nav-item.active > .cp-nav-link,\n    .cp-nav-link:active{\n        background:var(--surface-600) !important;\n    }\n    .cp-nav-link:hover{\n        background-color:var(--surface-600);\n    }\n    .cp-nav-submenu{\n        background:var(--surface-800);\n        .cp-nav-link:hover{\n            background-color:var(--surface-500);\n        }\n    }\n}\n@media only screen and (max-width:var(--media-tablet)) and (min-width:0px){\n    #left-panel{\n        width:300px;\n        max-width:300px;\n        left:-300px !important;\n        .cp-logo{\n            padding:32px 12px;\n        }\n        .cp-nav-link{\n            font-size:16px;\n            i.fas{\n                font-size:14px;\n                margin-right:8px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
